import { useSelector } from 'react-redux';
import { getIntakeStatesCovered, stateOptions } from '../../../helpers/states';
import { useAppDispatch } from '../../../pages/assessment';
import { selectPatient } from '../../../redux/assessment';
import { updateMeta } from '../../../redux/meta';
import { useLDFlags } from '../../providers/ld-flags';
import StateCheckScreen from '../screens/state-check';

const StateCheckScreenWrapper = () => {
  const dispatch = useAppDispatch();
  const patient = useSelector(selectPatient);
  const { listStatesSupported } = useLDFlags();
  const intakeStatesCovered = getIntakeStatesCovered(listStatesSupported);

  const onContinue = () => {
    dispatch(updateMeta());
  };

  return (
    <StateCheckScreen
      patientPreferredName={patient.preferredName}
      patientAddressState={patient.addressState}
      allStates={stateOptions}
      supportedStateCodes={intakeStatesCovered}
      onContinue={onContinue}
    />
  );
};

export default StateCheckScreenWrapper;
